import {Controller} from "@hotwired/stimulus";

import markerUrl from '../../images/map-icons/marker.png';
import Leaflet from 'leaflet/dist/leaflet.js';

export default class extends Controller {
  connect() {
    const position = [55.688760, 21.153187];

    const map = Leaflet.map(this.element, {
      center: position,
      zoom: 15,
      scrollWheelZoom: false,
    });

    Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: ''
    }).addTo(map);

    /*Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: '',
      id: 'cpartner/cl98ed34z001d15phw95qa4tm',
      tileSize: 512,
      zoomOffset: -1,
      accessToken: 'pk.eyJ1IjoiY3BhcnRuZXIiLCJhIjoiY2w5OGU3MzFhMm9tajNucW1lZzk2czJ0NiJ9.vWvne5qpcbkQWYPvUHXzug'
    }).addTo(map);*/

    Leaflet.marker(position, {
      icon: new (Leaflet.Icon.extend({
        options: {
          // iconSize:     [166, 138],
          iconAnchor:   [15, 18]
        }
      }))({iconUrl: markerUrl})
    }).addTo(map);
  }
}
